(function() {
  const CAMPUS_PRODUCT_IDS = [10683001798989, 10683001176397, 10678328820045];
  const VALORACION_PRODUCT_ID = 10688803307853;
  let isProcessing = false;

  async function getCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  async function addValoracion(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
  }

  async function getValoracionVariantId() {
    const data = await fetch('/products/valoracion-inicial.js').then(r => r.json()).catch(() => null);
    if (data && data.variants && data.variants.length > 0) {
      return data.variants[0].id;
    }
    return null;
  }

  // ── Bloquear eliminación de la Valoración ────────────────────────────────
  function lockValoracion() {
    document.querySelectorAll('a[href*="/products/"]').forEach(title => {
      if (title.textContent.toLowerCase().includes('valoraci')) {
        // Móvil: contenedor v-stack
        const mobileContainer = title.closest('.v-stack.justify-items-start.gap-2');
        if (mobileContainer) {
          mobileContainer.querySelectorAll('a[href*="quantity=0"]').forEach(link => {
            link.style.setProperty('display', 'none', 'important');
          });
        }
        // Desktop: contenedor <tr>
        const tr = title.closest('tr');
        if (tr) {
          tr.querySelectorAll('a[href*="quantity=0"]').forEach(link => {
            link.style.setProperty('display', 'none', 'important');
          });
        }
      }
    });
  }

  // Ejecutar al cargar página
  document.addEventListener('DOMContentLoaded', lockValoracion);

  // Ejecutar cada vez que el carrito cambie
  document.documentElement.addEventListener('cart:change', async function(event) {
    if (isProcessing) return;
    if (event.detail?.baseEvent === 'campus-addon') return;

    const cart = event.detail.cart;
    if (!cart || !cart.items) return;

    const hasCampus = cart.items.some(item => CAMPUS_PRODUCT_IDS.includes(item.product_id));
    const hasValoracion = cart.items.some(item => item.product_id === VALORACION_PRODUCT_ID);

    if (hasCampus && !hasValoracion) {
      isProcessing = true;
      const variantId = await getValoracionVariantId();
      if (variantId) {
        await addValoracion(variantId);
        const updatedCart = await getCart();
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'campus-addon', cart: updatedCart }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }
      isProcessing = false;
    }

    if (!hasCampus && hasValoracion) {
      isProcessing = true;
      const valoracionItem = cart.items.find(item => item.product_id === VALORACION_PRODUCT_ID);
      if (valoracionItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: valoracionItem.key, quantity: 0 })
        });
        const updatedCart = await getCart();
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'campus-addon', cart: updatedCart }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }
      isProcessing = false;
    }

    // Aplicar bloqueo tras cada cambio en el carrito
    setTimeout(lockValoracion, 300);
  });

  // Observar el cart drawer por si renderiza dinámicamente
  const observer = new MutationObserver(() => lockValoracion());
  const cartDrawer = document.querySelector('#cart-drawer, cart-drawer, #CartDrawer');
  if (cartDrawer) observer.observe(cartDrawer, { childList: true, subtree: true });

})();